<div class="error-container">
  <h1 class="error-text">{{ data.text }}</h1>

  <div class="confirm-actions" *ngIf="data.confirmMode">
    <button mat-stroked-button class="confirm-btn" (click)="onCancel()">{{ data.cancelText }}</button>
    <button mat-stroked-button class="confirm-btn" (click)="onConfirm()">{{ data.confirmText }}</button>
  </div>
</div>
